<ng-template>
  <div class="menu">
    <div (click)="handleClick()" class="menu-wrapper">
      <div class="menu-content menu-buttons">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</ng-template>
